import React from 'react';
import { ServicesSection } from '../components/ServicesSection';
export function ProductsPage() {
  return <div className="pt-28" data-id="element-784">
      <ServicesSection data-id="element-785" />
    </div>;
}